import ErrorReporterV1 from "./services/ErrorReporterV1";
import ErrorReport from "./services/ErrorReport";

export default ErrorReporterV1;
export { ErrorReport };
